const OrderMode = Object.freeze({
  NO_ORDER: 'NO_ORDER',
  MANUAL_ORDER: 'MANUAL_ORDER',
  AUTOMATIC_ORDER: 'AUTOMATIC_ORDER',
  RECEIVED: 'RECEIVED'
})

export default OrderMode
